import { Button } from "@/components/ui/button";
import { useState } from "react";

export default function Orcamento() {
    const [enviado, setEnviado] = useState(false);

    function handleSubmit(e: React.FormEvent<HTMLFormElement>) {
        e.preventDefault();
        // Aqui você pode integrar com backend/email
        setEnviado(true);
    }

    return (
        <div className="max-w-xl mx-auto py-12 px-4">
            <h1 className="text-2xl font-bold mb-4 text-center">Solicite sua Proposta Personalizada</h1>
            <p className="mb-6 text-center text-muted-foreground">
                Preencha os dados abaixo para receber um orçamento detalhado. O valor investido no diagnóstico/manual será descontado do projeto final.
            </p>
            {enviado ? (
                <div className="bg-green-100 text-green-800 rounded p-4 text-center">
                    Obrigado! Sua solicitação foi enviada. Em breve entraremos em contato com sua proposta.
                </div>
            ) : (
                <form onSubmit={handleSubmit} className="space-y-4">
                    <div>
                        <label className="block mb-1 font-medium">Nome</label>
                        <input required name="nome" className="w-full border rounded px-3 py-2" />
                    </div>
                    <div>
                        <label className="block mb-1 font-medium">E-mail</label>
                        <input required type="email" name="email" className="w-full border rounded px-3 py-2" />
                    </div>
                    <div>
                        <label className="block mb-1 font-medium">URL do site</label>
                        <input required name="site" className="w-full border rounded px-3 py-2" />
                    </div>
                    <div>
                        <label className="block mb-1 font-medium">Tecnologias utilizadas (WordPress, Wix, etc)</label>
                        <input name="tecnologias" className="w-full border rounded px-3 py-2" />
                    </div>
                    <div>
                        <label className="block mb-1 font-medium">Descreva suas necessidades e objetivos</label>
                        <textarea required name="objetivos" className="w-full border rounded px-3 py-2 min-h-[80px]" />
                    </div>
                    <Button type="submit" className="w-full">Enviar solicitação</Button>
                </form>
            )}
        </div>
    );
}
